import { html, LitElement } from "lit-element";
import { StofwareElement } from "@stofloos/core/base/sw-element";

import { styles } from "./style";
import { template } from "./template";
import {findAllElement, findElement, findHost, operators} from "@stofloos/utils/sw-constants";
import { connect } from "pwa-helpers/connect-mixin";
import { store } from "@stofloos/stores/store";

import { initRequest } from "@stofloos/actions/requests";
import { readObject } from "@stofloos/actions/crud";



export const checkCondition = (condition, element) => {
	let host = findHost(element);
	let selector = condition.selector ? host.querySelector(condition.selector) : element;
	let value;
	if (!selector) {
		return;
	}
	// Use value or checked attribute based on input type
	if (selector.hasAttribute("checkbox-list-item")) {
		value = host.querySelector("input[value='" + condition.value + "']").checked;
	} else if (selector.type === "checkbox") {
		value = selector.checked;
	} else {
		value = selector.value;
	}
	if (selector.hasAttribute("checkbox-list-item") && value) {
		return true;
	} else {
		return operators[condition.operator](value, condition.value);
	}
};


class StofwareForm extends connect(store)(LitElement) {
	static get styles() {
		return styles;
	}

	render() {
		if (!this.config) {
			return "";
		}

		// HACK: the shadowRoot elements are not yet renderded and can therefor not be selected
		setTimeout(() => {
			this.config.forEach(row => {
				this.hideFormElements(row.elements);
			});
		}, 100);

		return html`
			${template(this, this.object, false)}
		`;
	}

	constructor() {
		super();
		this.formIsVisible = true;
		this.object = {};
	}

	firstUpdated(_changedProperties) {
		super.firstUpdated(_changedProperties);
		if (this.summary) {
			this.formIsVisible = true;
		}
	}

	update(changedProperties) {
		super.update(changedProperties);

		if (
			changedProperties.has("formId") &&
			typeof this.formId !== "undefined" &&
			typeof this.config === "undefined"
		) {
			const state = store.getState();
			this.shouldMakeRequest(state);
		}
	}

	shouldMakeRequest(state) {
		const name = "swFormSingle" + this.formId;
		if (
			this.formId &&
			typeof state.crud[name] === "undefined" &&
			typeof state.requests[name] === "undefined" &&
			typeof this.config === "undefined" &&
			!this.isLoading
		) {
			this.isLoading = true;
			store.dispatch(initRequest(name, "form"));
			store.dispatch(readObject(name, this.formId, true)).then(response => {
				this.config = response.definition;
				this.isLoading = false;
			});
		} else if (typeof state.crud[name] !== "undefined" && typeof this.config === "undefined") {
			this.config = state.crud[name].definition;
		}
	}

	stateChanged(state) {
		this.shouldMakeRequest(state);
	}

	doActions(element, listener) {
		listener.actions.forEach(action => {
			if (typeof action.target === "undefined") {
				action.target = '[data-collection="' + element.name + '-children"]';
			}

			if (action.type === "set-value") {
				// This is the element itself
				const target = this.shadowRoot.querySelector(
					'select[name="' + element.name + '"], input[name="' + element.name + '"]'
				);

				action.conditions.some(condition => {
					// This is the element to check the value
					const elm = this.shadowRoot.querySelector(condition.target);

					if (checkCondition(condition, elm)) {
						target.value = condition.set;
						return true;
					}
				});
			}

			if (action.type === "substract") {
				// This is the element itself
				const target = this.shadowRoot.querySelector('input[name="' + element.name + '"]');

				let total = 0;
				if(target){
					listener.targets.forEach(
						function(target, index) {
							const elms = this.shadowRoot.querySelectorAll(target);

							elms.forEach(function(elm) {
								if (index === 0 && elm.value) {
									total = parseInt(elm.value);
								} else if (elm.value) {
									total = total - parseInt(elm.value);
								}
							});
						}.bind(this)
					);
					target.value = total;
					const event = new Event("change");
					target.dispatchEvent(event);
				}
			}

			if (action.type === "sum") {
				// This is the element itself
				const target = this.shadowRoot.querySelector('input[name="' + element.name + '"]');

				let total = 0;
				listener.targets.forEach(
					function (target) {
						const elms = this.shadowRoot.querySelectorAll(target);

						elms.forEach(function (elm) {
							if (elm.value) {
								total = total + parseInt(elm.value);
							}
						});
					}.bind(this)
				);
				if (target) {
					target.value = total;
					const event = new Event("change");
					target.dispatchEvent(event);
				}
			}

			if (action.type === "show") {
				// Reset visiblity if action is show for targets
				// This action should be put on the element which triggers the visible / hidden event
				let selector = action.target;
				const targets = findAllElement(this, selector);
				if(targets) {
					targets.forEach(target => {
						target.style.display = "none";
						target.classList.add("conditional-hidden");
					});

					const currentElement = findElement(this, '[name="' + element.name + '"]');
					action.conditions.forEach(condition => {
						let input;
						if(currentElement instanceof HTMLInputElement) {
							input = currentElement;
						} else {
							input = findElement(currentElement, "input, select, textarea");
						}
						if (checkCondition(condition, input)) {
							targets.forEach(target => {
								target.style.display = "";
								target.classList.remove("conditional-hidden");
							});
						}
					});
				}
			}

			if (action.type === "show-if") {
				// This is the element itself, This action should be put on the element which needs to be visible / hidden
				const target = this.shadowRoot.querySelector('[data-name="' + element.name + '"]');

				if(target) {
					action.conditions.some(condition => {
						// This is the element to check the value
						const elm = findElement(this, condition.target);
						if (target) {
							if (checkCondition(condition, elm)) {
								target.style.display = "";
								target.classList.remove("conditional-hidden");
								return true;
							} else {
								target.classList.add("conditional-hidden");
								target.style.display = "none";
							}
						}
					});
				}
			}
		});
	}

	hideFormElements(elements) {
		if (typeof elements === "undefined") {
			return;
		}
		elements.forEach(element => {
			if (element.children && element.children.length > 0) {
				element.children.forEach(child => {
					if (child.elements && child.elements.length > 0) {
						this.hideFormElements(child.elements);
					}
				});
			}
			if (!("listeners" in element)) {
				return;
			}

			let listeners = element.listeners;

			const dataPrefix = this.dataPrefix ? this.dataPrefix : "";

			// Add [] for all array elements
			if(element.type === "checkbox-list") {
				element.name= element.name+"[]";
			}

			listeners.forEach(listener => {
				if (listener.targets) {
					listener.targets.forEach(target => {
						const targetElms = findAllElement(this, target);
						targetElms.forEach(targetElm => {
							targetElm.addEventListener(listener.type, () => this.doActions(element, listener));
						});
						this.doActions(element, listener);
					});
				} else {

					const targetElms = findAllElement(
						this,
						'input[name="' +
							dataPrefix +
							element.name +
							'"], select[name="' +
							dataPrefix +
							element.name +
							'"], textarea[name="' +
							dataPrefix +
							element.name +
							'"]'
					);

					if (targetElms) {
						targetElms.forEach(targetElm => {
							targetElm.addEventListener(listener.type, () => this.doActions(element, listener));
						});
						this.doActions(element, listener);
					}
				}

				listener.actions.forEach(action => {
					if (action.type !== "show") {
						return;
					}
					if (typeof action.target === "undefined") {
						action.target = '[data-collection="' + element.name + '-children"]';
					}
					const targets = findAllElement(this, action.target);

					// Reset visiblity if action is show for targets
					if (targets && targets.length > 0) {
						if (action.type === "show") {
							targets.forEach(target => {
								target.classList.add("conditional-hidden");
								target.style.display = "none";
							});
							action.conditions.forEach(condition => {
								let elm = condition.selector
									? findElement(this, target)
									: findElement(
											this,
											'input[name="' +
												dataPrefix +
												element.name +
												'"], input[name="' +
												dataPrefix +
												element.name +
												'[]"], select[name="' +
												dataPrefix +
												element.name +
												'"]'
									  );
								if (checkCondition(condition, elm)) {
									targets.forEach(target => {
										target.classList.remove("conditional-hidden");
										target.style.display = "";
									});
								}
							});
						}
					}
				});
			});
		});
	}

	static get properties() {
		return {
			config: { type: Array },
			summary: { type: Array },
			formIsVisible: { type: Boolean },
			object: { type: Object },
			formId: { type: Number },
			dataPrefix: { type: String }
		};
	}

	showForm() {
		this.formIsVisible = true;
	}

	hideForm() {
		this.formIsVisible = false;
	}

	toggleForm() {
		this.formIsVisible = !this.formIsVisible;
	}
}

window.customElements.define("sw-form", StofwareForm);
